let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6iS4F")).then(() => parcelRequire('jfPKi'));